module.exports = __webpack_public_path__ + "img/photo-15.d6f82191.jpg";